

const ZDANIA = [ 
  {
    name: 'Niemiecki: Mieszaknie, pomieszczenia, określenia małe duże, mój, twój itp.',
    lang: 'de',
    zdania: [
      {
        de: 'Wie ist deine Küche?',
        pl: 'Jaka jest twoja kuchnia?',
      },
      {
        de: 'das Zimmer',
        pl: 'Pokój',
      },
      {
        de: 'das Wohnzimmer',
        pl: 'Salon/Pokój dzienny',
      },
      {
        de: 'das Bad',
        pl: 'Łazienka',
      },
      {
        de: 'Das Wohnzimmer',
        pl: 'Salon/Pokój dzienny',
      },
      {
        de: 'der Abstellarum',
        pl: 'Pomieszczenie gospodarcze',
      },
      {
        de: 'das Esszimmer',
        pl: 'Jadalnia',
      },
      {
        de: 'Das Wohnzimmer',
        pl: 'Salon/Pokój dzienny',
      },
      {
        de: 'die Küche',
        pl: 'Kuchnia',
      },
      {
        de: 'das Schlafzimmer',
        pl: 'Sypialnia',
      },
      {
        de: 'der Garten',
        pl: 'Ogród',
      },
      {
        de: 'das Arbeitszimmer',
        pl: 'pracownia',
      },
      {
        de: 'der Wohnblock',
        pl: 'blok mieszkalny',
      },
      {
        de: 'der Garten',
        pl: 'Ogród',
      },
      {
        de: 'Welche zimmer hast du zu hause?',
        pl: 'Które/Jakie pokoje masz w mieszkaniu?',
      },
      {
        pl: 'Mam pokój',
        de: 'Ich habe ein Zimmer',
      },
      {
        pl: 'Mam sypialnię',
        de: 'Ich habe ein Schlafzimmer',
      },
      {
        pl: 'Mam kuchnię',
        de: 'Ich habe eine Küche',
      },
      {
        pl: 'Mam ogród',
        de: 'Ich habe einen Garten',
      },
      {
        pl: 'Czy ty masz ogród?',
        de: 'Hast du einen Garten?',
      },
      {
        pl: 'Czy ty masz ogród?',
        de: 'Hast du einen Garten?',
      },
      {
        pl: 'To jest sypialnia Stefana. Ona jest duża',
        de: 'Das ist Schlafzimmer von Stefan. Es ist groß',
      },
      {
        pl: 'To jest salon Markusa i Pani Malin',
        de: 'Das ist Wohnzimmer von Markus und Frau Malin',
      },
      {
        pl: 'Co to jest?',
        de: 'Was ist das?',
      },
      {
        pl: 'Skąd jesteś?',
        de: 'Woher kommst du?',
      },
      {
        pl: 'Kim ona jest?',
        de: 'Wer ist sie?',
      },
      {
        pl: 'Kto to jest?',
        de: 'Wer ist das?',
      },
      {
        pl: 'Gdzie jesteś?',
        de: 'Wo bist du?',
      },
      {
        pl: 'Jak się masz?',
        de: "Wie geht's?",
      },
      {
        pl: 'Kim Pani jest?',
        de: 'Wer sind Sie?',
      },
      {
        pl: 'Nazywam się Julian',
        de: 'Ich heiße Julian',
      },
      {
        pl: 'Ile masz lat?',
        de: 'Wie alt bist du?',
      },
      {
        pl: 'duży',
        de: 'groß',
      },
      {
        pl: 'bardzo',
        de: 'sehr',
      },
      {
        pl: 'mały',
        de: 'klein',
      },
      {
        pl: 'Jej sypialnia jest bardzo duża',
        de: 'Ihr Schlafzimmer ist sehr groß'
      },
      {
        pl: 'Czy ona ma kuchnię?',
        de: 'Hat sie eine Küche?',
      },
      {
        pl: 'Twój salon/pokój dzienny jest bardzo duży',
        de: 'Dein Wohnzimmer ist sehr groß'
      },
      {
        pl: 'Twój salon/pokój dzienny jest bardzo duży',
        de: 'Dein Wohnzimmer ist sehr groß'
      },
      {
        pl: 'Jego sypialnia jest bardzo mała',
        de: 'Sein Schlafzimmer ist sehr klein'
      },
      {
        pl: 'Jaka jest Twoja łazienka?',
        de: 'Wie ist dein bad?'
      },
      {
        pl: 'Mamy pomieszczenie gospodarcze',
        de: 'Wir haben einen Abstellarum'
      }
    ]
  },
  {
    name: 'Niemiecki: cz.2',
    lang: 'de',
    zdania: [ 
      {
        pl: 'łóżko',
        de: 'das Bett',
      },
      {
        pl: 'szafa',
        de: 'der Shrank',
      },
      {
        pl: 'stół',
        de: 'der Tish',
      },
      {
        pl: 'Łazienka',
        de: 'das Bad',
      },
      {
        pl: 'krzesło',
        de: 'der Stuhl',
      },
      {
        pl: 'prysznic',
        de: 'die Dusche',
      },
      {
        pl: 'komputer',
        de: 'der Computer',
      },
      {
        pl: 'sofa',
        de: 'das Sofa',
      },
      {
        pl: 'regał',
        de: 'das Regal',
      },
      {
        pl: 'drzewo',
        de: 'der Baum',
      },
      {
        pl: 'lampa',
        de: 'die Lampe',
      },
      {
        pl: 'Łazienka nie jest bardzo duża',
        de: 'Das Bad ist nicht sehr groß',
      },
      {
        pl: 'Ogórd jest bardzo ładny',
        de: 'Der Garten ist sehr schön',
      },
      {
        pl: 'Kuchnia jest praktyczna',
        de: 'Die Küche ist praktisch',
      },
      {
        pl: 'Pokój do pracy jest duży',
        de: 'Das Arbeitszimmer ist groß',
      },
      {
        pl: 'Sypialnia jest mała',
        de: 'Das Schlafzimmer ist klein',
      },
      {
        pl: 'Pokój dzinny jest wygodny',
        de: 'Das Wohnzimmer ist gemütlich',
      },
      {
        pl: 'Pomieszczenie gospodarcze jest użyteczne',
        de: 'Der Abstellarum ist nützlich',
      },
      {
        pl: 'Co to jest?',
        de: 'Was ist das?',
      },
      {
        pl: 'To jest lampa',
        de: 'Das ist eine Lampe',
      },
      {
        pl: 'To nie jest lampa',
        de: 'Das ist keine Lampe',
      },
      {
        pl: 'To jest krzesło',
        de: 'Das ist ein Stuhl',
      },
      {
        pl: 'To nie jest krzesło',
        de: 'Das ist kein Stuhl',
      },
      {
        pl: 'To jest sofa',
        de: 'Das ist ein Sofa',
      },
      {
        pl: 'To nie jest sofa',
        de: 'Das ist kein Sofa',
      },
      {
        pl: 'To jest stół',
        de: 'Das ist ein Tish',
      },
      {
        pl: 'To nie jest stół',
        de: 'Das ist kein Tish',
      },
      {
        pl: 'To jest komputer',
        de: 'Das ist ein Computer',
      },
      {
        pl: 'To nie jest komputer',
        de: 'Das ist kein Computer',
      },
      {
        pl: 'To jest łóżko',
        de: 'Das ist ein Bett',
      },
      {
        pl: 'To nie jest łóżko',
        de: 'Das ist kein Bett',
      },
      {
        pl: 'To jest prysznic',
        de: 'Das ist eine Dusche',
      },
      {
        pl: 'To nie jest prysznic',
        de: 'Das ist keine Dusche',
      },
      {
        pl: 'To nie jest prysznic',
        de: 'Das ist keine Dusche',
      }
      ,
      {
        pl: 'Nie, to nie jest komputer. To jest lampa',
        de: 'Nein, das ist kein Computer. Das ist eine Lampe',
      },
      {
         pl: 'Nie, to nie jest lampa. To jest drzewo',
        de: 'Nein, das ist keine Lampe. Das ist ein Baum',
      }
    ]
  },
  {
    name: 'Niemiecki: Module 2, Kapitel: 2',
    lang: 'de',
    zdania: [ 
      {
        pl: 'wizyta/odwiedziny',
        de: 'Ein besuch',
      },
      {
        pl: 'Pomidory',
        de: 'Die Tomaten',
      },
      {
        pl: 'Gorące mleko',
        de: 'Die heiße Milch',
      },
      {
        pl: 'Proszę, wejdźcie',
        de: 'Bitte, kommen Sie rein',
      },
      {
        pl: 'Co słychać u pana / pani / państwa?',
        de: "Wie geht's Ihnen?",
      },
      {
        pl: 'Mam się dobrze, dziękuję',
        de: "Mir geht's gut, danke.",
      },
      {
        pl: 'Gdzie jest Tina?',
        de: 'Wo ist Tina?',
      },
      {
        pl: 'Pani Stiein, czy chce Pani coś do picia? Filiżankę kawy?',
        de: 'Frau Stein, möchten Sie etwas trinken? Eine Tasse Kaffee?',
      },
      {
        pl: 'Nie dziękuję.',
        de: 'Nein, danke.'
      },
      {
        pl: 'A ty Brigitte? Chcesz też coś do picia?',
        de: 'Und du Brigitte? Möchtest du auch etwas trinken?',
      },
      {
        pl: 'Sok pomarańczowy',
        de: 'Der Orangensaft',
      },
      {
        pl: 'Nie, wolę filiżankę herbaty.',
        de: 'Nein, ich möchte lieber eine Tasse Tee.',
      },
      {
        pl: 'Nie, wolę puszkę Coli.',
        de: 'Nein, ich möchte lieber eine Dose Cola.',
      },
      {
        pl: 'filiżanka herbaty',
        de: 'eine Tasse Tee',
      },
      {
        pl: 'butelka',
        de: 'eine Flasche',
      },
      {
        pl: 'szklanka mleka',
        de: 'ein Glass Milch',
      },
      {
        pl: 'puszka Coli',
        de: 'eine Dose Cola',
      },
      {
        pl: 'Czy pijesz puszkę Coli?',
        de: 'Trinkst du eine Dose Cola?',
      },
      {
        pl: 'Co chcesz pić, Brigitte? Szklankę mleka?',
        de: 'Was möchtest du trinken, Brigitte? Ein Glas Milch?',
      },
      {
        pl: 'Co Pani chce pić, Pani Stein? Filiżankę Kawy?',
        de: 'Was möchten Sie trinken, Frau Stein? Eine Tasse Kaffee?',
      },
      {
        pl: 'Piję Kakao',
        de: 'Ich trinke eine Kakao',
      },
      {
        pl: 'Sok jabłkowy',
        de: 'Der Apfelsaft',
      },
      {
        pl: 'Piję wodę',
        de: 'Ich trinke ein Wasser',
      },
      {
        pl: 'Piję herbatę',
        de: 'Ich trinke einen Tee',
      },
      {
        pl: 'Piję kawę',
        de: 'Ich trinke einen Kaffee',
      },
      {
        pl: 'Szynka',
        de: 'Der Schinken',
      },
    ]
  },
  {
    name: 'Julian: ENG: Kraje i narodowości ',
    lang: 'en',
    zdania: [ 
      {
        pl: 'Zjednoczone Królestwo',
        de: 'United Kingdom',
      },
      {
        pl: 'Brytyjczyk',
        de: 'British',
      },
      {
        pl: 'Szkocja',
        de: "Scotland",
      },
      {
        pl: 'Północna Irlandia',
        de: "Northern Ireland",
      },
      {
        pl: 'Irlandczyk',
        de: 'Irish',
      },
      {
        pl: 'Walia',
        de: 'Wales',
      },
      {
        pl: 'Welsh',
        de: 'Walijczyk'
      },
      {
        pl: 'Dania',
        de: 'Denmark',
      },
      {
        pl: 'Finlandia',
        de: 'Finland',
      },
      {
        pl: 'Fin (mieszkaniec Finlandi)',
        de: 'Finnish',
      },
      {
        pl: 'Norwegia',
        de: 'Norway',
      },
      {
        pl: 'Norweg',
        de: 'Norwegian',
      },
      {
        pl: 'Szwecja',
        de: 'Sweden',
      },
      {
        pl: 'Szwed',
        de: 'Swedish',
      },
      {
        pl: 'Szwajcaria',
        de: 'Switzerland',
      },
      {
        pl: 'Szwajcar',
        de: 'Swiss',
      },
      {
        pl: 'Belgia',
        de: 'Belgium',
      },
      {
        pl: 'Belg (mieszkaniec Belgi)',
        de: 'Belgian',
      },
      {
        pl: 'Francja',
        de: 'France',
      },
      {
        pl: 'Francuz',
        de: 'French',
      },
      {
        pl: 'Niemiec',
        de: 'German',
      },
      {
        pl: 'Niemcy',
        de: 'Germany',
      },
      {
        pl: 'Włochy',
        de: 'Italy',
      },
      {
        pl: 'Włoch',
        de: 'Italian',
      },
      {
        pl: 'Stany Zjednoczone',
        de: 'United States',
      },
      {
        pl: 'Amerykanin',
        de: 'American',
      },
      {
        pl: 'Kanada',
        de: 'Canada',
      },
      {
        pl: 'Ukraina',
        de: 'Ukraine',
      },
      {
        pl: 'Ukrainiec',
        de: 'Ukrainian',
      },
      {
        pl: 'Rosja',
        de: 'Russia',
      },
      {
        pl: 'Rosjanin',
        de: 'Russian',
      },
      {
        pl: 'Polska',
        de: 'Poland',
      },
      {
        pl: 'Polak',
        de: 'Polish',
      },
      {
        pl: 'Polska',
        de: 'Poland',
      },
      {
        pl: 'Czechy',
        de: 'Czech Republic',
      },
      {
        pl: 'Czech',
        de: 'Czech',
      },
      {
        pl: 'Grecja',
        de: 'Greece',
      },
      {
        pl: 'Greek',
        de: 'Grek',
      },
      {
        pl: 'Hiszpania',
        de: 'Spain',
      },
      {
        pl: 'Hiszpan',
        de: 'Spanish',
      },
      {
        pl: 'Portugalia',
        de: 'Portugal',
      },
      {
        pl: 'Portugalczyk',
        de: 'Portuguese',
      },
      {
        pl: 'Chiny',
        de: 'China',
      },
      {
        pl: 'Chińczyk',
        de: 'Chinese',
      },
      {
        pl: 'Japonia',
        de: 'Japan',
      },
      {
        pl: 'Japończyk',
        de: 'Japanese',
      },
      {
        pl: 'Japonia',
        de: 'Japan',
      },
      {
        pl: 'Niemcy ',
        de: 'Germany',
      },
      {
        pl: 'Niemiec',
        de: 'German',
      },
      {
        pl: 'Litwa',
        de: 'Lithuania',
      },
      {
        pl: 'Litwin',
        de: 'Lithuanian',
      },
      {
        pl: 'Duńczyk',
        de: 'Danish',
      },
      {
        pl: 'Dania',
        de: 'Denmark',
      },
    ]
  }, 
  {
    name: 'Mama: Angielski cz. II',
    lang: 'en',
    zdania: [ 
      {
        pl: 'przedsiębiorca',
        de: 'entrepreneur',
      },
      {
        pl: 'główna siedziba',
        de: 'headquarter',
      },
      {
        pl: 'sektor finansowy',
        de: "financial sector",
      },
      {
        pl: 'financial hub',
        de: "centrum finansowe",
      },
      {
        pl: 'ponosić koszty',
        de: 'bear the cost',
      },
      {
        pl: 'wysokie koszty utrzymania/życia',
        de: 'high cost of living',
      },
      {
        pl: 'bank inwestycyjny',
        de: 'investment bank'
      },
      {
        pl: 'dzielnica biznesowa',
        de: 'business district',
      },
      {
        pl: 'autonomia',
        de: 'autonomy',
      },
      {
        pl: 'gmina',
        de: 'commune',
      },
      {
        pl: 'dzielnica',
        de: 'discrict',
      },
      {
        pl: 'rząd lokalny',
        de: 'local government',
      },
      {
        pl: 'działalność zarobkowa',
        de: 'gainful employment',
      },
      {
        pl: 'pozwolenie na pracę',
        de: 'work permit',
      },
      {
        pl: 'samozatrudniony',
        de: 'self employed',
      },
      {
        pl: 'przyznać komuś coś',
        de: 'grant somebody something',
      },
      {
        pl: 'pożyczka',
        de: 'loan',
      },
      {
        pl: 'przysługujące prawo, pozwolenie',
        de: 'legal right',
      },
      {
        pl: 'dochód',
        de: 'income',
      },
      {
        pl: 'lista, zestawienie wydatków, przychodów',
        de: 'tally',
      },
      {
        pl: 'nietakt',
        de: 'faux pas',
      },
      {
        pl: 'wrażenie',
        de: 'impression',
      },
      {
        pl: 'wyraz twarzy, mimika',
        de: 'facial expression',
      },
      {
        pl: 'etykieta',
        de: 'etiquette',
      },
      {
        pl: 'znajdować złoty środek',
        de: 'strike a balance',
      },
      {
        pl: 'ignorancja',
        de: 'ignorance',
      },
      {
        pl: 'znajdować złoty środek',
        de: 'strike a balance',
      },
      {
        pl: 'międzykulturowy',
        de: 'cross-cultural',
      },
      {
        pl: 'szanować, poważać',
        de: 'respect',
      },
      {
        pl: 'przestrzeń osobista',
        de: 'personal space',
      },
      {
        pl: 'wizytówka',
        de: 'business card',
      },
      {
        pl: 'różnica płciowa',
        de: 'gender difference',
      },
      {
        pl: 'wpływowy',
        de: 'high-powered',
      },
      {
        pl: 'strój',
        de: 'attire',
      },
      {
        pl: 'gospodarczy',
        de: 'economic',
      }
    ]
  },
  {
    name: 'Mama: Angielski cz. III',
    lang: 'en',
    zdania: [ 
      {
        pl: 'demotywacja',
        de: 'demotivation',
      },
      {
        pl: 'osiągnąć',
        de: 'achieve',
      },
      {
        pl: 'wypalić się zawodowo',
        de: "burn out",
      },
      {
        pl: 'wymagająca (np. praca)',
        de: "demanding",
      },
      {
        pl: 'zakończyć zadanie',
        de: 'complete a task',
      },
      {
        pl: 'delegować',
        de: 'delegate',
      },
      {
        pl: 'czasochłonny',
        de: 'time consuming'
      },
      {
        pl: 'wtrącać sie, kolidować, ingerować',
        de: 'interfere',
      },
      {
        pl: 'przełamywać ograniczenia',
        de: 'push the limits',
      },
      {
        pl: 'przeceniać czyjeś siły',
        de: "overplay one's hand"
      },
      {
        pl: 'pogoń, dążenie',
        de: 'pursuit',
      },
      {
        pl: 'żyć zgodnie z czymś',
        de: 'live up to something',
      },
      {
        pl: 'podejmować się mniej wymagających zobowiązań w celu zdrowotnego stylu życia',
        de: 'downshift',
      },
      {
        pl: 'monotonna praca lub życie',
        de: 'treadmill',
      },
      {
        pl: 'zmęczenie, wyczerpanie',
        de: 'exhaustion',
      },
      {
        pl: 'przetłoczony',
        de: 'overwhelmed',
      },
      {
        pl: 'wyścig szczurów',
        de: 'rat race',
      }
    ]
  },
  {
    name: 'Julian: Niemiecki - Kapitel 3 Modul 2',
    lang: 'de',
    zdania: [ 
      {
        pl: 'pies',
        de: 'der Hund',
      },
      {
        pl: 'kot',
        de: 'die Katze',
      },
      {
        pl: 'der',
        de: "Kanarienvogel",
      },
      {
        pl: 'złota rybka',
        de: "der Goldfisch",
      },
      {
        pl: 'krowa',
        de: 'die Kuh',
      },
      {
        pl: 'koń',
        de: 'das Pferd',
      },
      {
        pl: 'mysz',
        de: 'die Maus'
      },
      {
        pl: 'królik',
        de: 'das Kaninchen',
      },
      {
        pl: 'chomik',
        de: 'der Hamster',
      },
      {
        pl: 'papuga',
        de: "der Papagei"
      },
      {
        pl: 'wilk',
        de: 'der Wolf',
      },
      {
        pl: 'ona daje dużo mleka',
        de: 'Sie gibt viel Milch',
      },
      {
        pl: 'Mam psa',
        de: 'Ich habe einen Hund',
      },
      {
        pl: 'Mam złotą rybkę',
        de: 'Ich habe einen Goldfisch',
      },
      {
        pl: 'Mam chomika',
        de: 'Ich habe einen Hamster',
      },
      {
        pl: 'Mam papugę',
        de: 'Ich habe einen Papagei',
      },
      {
        pl: 'Mam kanarka',
        de: 'Ich habe einen Kanarienvogel',
      },
      {
        pl: 'Mam kota',
        de: 'Ich habe eine Katze',
      },
      {
        pl: 'Mam myszkę',
        de: 'Ich habe eine Maus',
      },
      {
        pl: 'Mam krowę',
        de: 'Ich habe eine Kuh',
      },
      {
        pl: 'Mam konia',
        de: 'Ich ein ein Pferd',
      },
      {
        pl: 'Mam królika',
        de: 'Ich habe ein Kaninchen',
      },
      {
        pl: 'Czy masz zwierzęta domowe?',
        de: 'Hast du Haustiere?',
      },
      {
        pl: 'Tak, mam psa.',
        de: 'Ja, ich habe einen Hund.',
      },
      {
        pl: 'Nie, niestety nie mam żadnych zwierząt domowych.',
        de: 'Nein, ich habe leider keine Haustiere.',
      },
      {
        pl: 'Tak, mam dwie złote rybki.',
        de: 'Ja, ich habe zwei Goldfische.',
      },
      {
        pl: 'Czy masz chomika?',
        de: 'Hast du einen Hamster?',
      },
      {
        pl: 'Nie, nie mam chomika.',
        de: 'Nein, ich habe keinen Hamster.',
      },
      {
        pl: 'Czy masz konia?',
        de: 'Hast du ein Pferd?',
      },
      {
        pl: 'Nie, nie mam konia.',
        de: 'Nein, ich habe kein Pferd.',
      },
      {
        pl: 'Czy lubisz papugi?',
        de: 'Magst du Papageien?',
      },
      {
        pl: 'Czy lubisz konie?',
        de: 'Magst du Pferde?',
      },
      {
        pl: 'Tak, bardzo lubię konie.',
        de: 'Ja, ich mag Pferde sehr.',
      },
      {
        pl: 'Nie, nie lubię papug.',
        de: 'Nein, ich mag keine Papageien.',
      },
      {
        pl: 'Czy lubisz zwierzęta?',
        de: 'Magst du Tiere?',
      },
      {
        pl: 'Tak, lubię zwierzęta.',
        de: 'Ja, ich mag Tiere.',
      },
      {
        pl: 'Nie, nie lubię zwierząt.',
        de: 'Nein, ich mag keine Tiere',
      },
      {
        pl: 'Czy ona lubi koty?',
        de: 'Mag sie Katzen?',
      },
      {
        pl: 'Ona nie lubi kanarków.',
        de: 'Sie mag keine Kanarienvögel.',
      },
      {
        pl: 'Czy oni lubią psy?',
        de: 'Mögen Sie Hunde?',
      },
      {
        pl: 'Kto nie lubi koni?',
        de: 'Wer mag keine Pferde?',
      },
      {
        pl: 'Czy Pani nie ma kanarka?',
        de: 'Haben Sie keinen Kanarienvogel?',
      },
      {
        pl: 'Wy nie macie chomika?',
        de: 'Sie haben keinen Hamster?',
      },
      {
        pl: 'Jak się nazywa Twój piec?',
        de: 'Wie heißt dein Hund?',
      }
    ]
  },
  {
    name: 'Julian: Angielski',
    lang: 'en',
    zdania: [ 
      {
        pl: 'Jaki on jest?',
        de: 'What is he like?',
      },
      {
        pl: 'pracowity',
        de: 'hardworking',
      },
      {
        pl: 'sprytny',
        de: "clever",
      },
      {
        pl: 'mądry',
        de: "smart",
      },
      {
        pl: 'inteligenty',
        de: 'intelligent',
      },
      {
        pl: 'genialny (wpisz dwa możliwe słowa po przecinku na g... i b....)',
        de: 'genious, brilliant',
      },
      {
        pl: 'nieśmiały',
        de: 'shy'
      },
      {
        pl: 'odważny',
        de: 'brave',
      },
      {
        pl: 'na luzie',
        de: 'easy-going',
      },
      {
        pl: 'miły',
        de: "nice"
      },
      {
        pl: 'gawędziarz, lubiący gadać',
        de: 'chatty',
      },
      {
        pl: 'miły (podać dwie możliwości po przecinku na k... i na n...)',
        de: 'kind/nice',
      },
      {
        pl: 'przyjazny',
        de: 'friendly',
      },
      {
        pl: 'nieprzyjazny',
        de: 'unfriendly',
      },
      {
        pl: 'uczciwy',
        de: 'honest',
      },
      {
        pl: 'leniwy',
        de: 'lazy',
      },
      {
        pl: 'złośliwy,wredny (jedno słowo)',
        de: 'mean',
      },
      {
        pl: 'paskudny',
        de: 'nasty',
      },
      {
        pl: 'skromny',
        de: 'humble',
      },
      {
        pl: 'hojny',
        de: 'generous',
      },
      {
        pl: 'niegrzeczny (dwa słowa napisz po przecinku r...., i....)',
        de: 'rude, impolite',
      },
      {
        pl: 'samolubny',
        de: 'selfish',
      },
      {
        pl: 'schludny, porządny',
        de: 'tidy',
      },
      {
        pl: 'próżny',
        de: 'vain',
      },
      {
        pl: 'cichy',
        de: 'quiet',
      },
      {
        pl: 'głośny',
        de: 'loud',
      },
      {
        pl: 'poważny',
        de: 'serious',
      },
      {
        pl: 'Jaki jest Twój najepszy przyjaciel?',
        de: 'What is your best friend?',
      },
      {
        pl: 'wiek',
        de: 'age',
      },
      {
        pl: 'narodowość',
        de: 'nationality',
      },
      {
        pl: 'On ma 10 lat',
        de: 'He is 10 years old',
      },
      {
        pl: 'Ona ma 20 lat',
        de: 'She is 20 years old',
      },
      {
        pl: 'On jest poważny i przyjazny',
        de: 'He is seroius and friendly',
      },
      {
        pl: 'Ona nie jest złośliwa',
        de: "She isn't nasty",
      },
      {
        pl: 'Jestem z Polski',
        de: "I'm from Poland",
      },
      {
        pl: 'Ona jest uczciwa',
        de: 'She is honest',
      }
    ]
  },
  {
    name: 'Julian: Niemiecki - Kapitel 4 Modul 2',
    lang: 'de',
    zdania: [ 
      {
        pl: 'Pan Martinez mieszka w Barcelonie',
        de: 'Herr Martinez wohnt in Barcelona',
      },
      {
        pl: 'Pan Martinez mówi tylko trochę po niemiecku',
        de: 'Herr Martinez spricht nur ein wenig Deutsch',
      },
      {
        pl: 'Pan Martinez ma restaurację w cenum Augsuburga',
        de: "Herr Martinez hat ein Restaurant im Zentrum von Augsburg",
      },
      {
        pl: 'Pan Martinez ma dwóch synów',
        de: "Herr Martinez hat zwei Söhne",
      },
      {
        pl: 'Pan Martinez lubi mieszkać w Niemczech',
        de: 'Herr Martinez lebt gern in Deutschland',
      },
      {
        pl: 'Pani Martinez też lubi mieszać w Niemczech',
        de: 'Frau Martinez lebt auch gern in Deutschland',
      },
      {
        pl: 'Restauracja Pana Martineza nazywa sie Casa de Tapas',
        de: 'Das Restaurant von Herr Martinez heißt Casa de Tapas'
      },
      {
        pl: 'Wiedeń',
        de: 'Wien',
      },
      {
        pl: 'Monachium',
        de: 'München',
      },
      {
        pl: 'On jest sąsiadem rodziny (państwa) Malin',
        de: "Er ist der Nachbar von Familie Malin"
      },
      {
        pl: 'Od już od dziesięciu lat mieszka w Augsburgu ',
        de: 'Er wohn schon seit zehn Jahren in Augsburg',
      },
      {
        pl: 'On sprzedaje hiszpańskie specjalności',
        de: 'Er verkauft spaische Spezialitäten',
      },
      {
        pl: 'On ma dwójkę dzieci',
        de: 'Er hat zwei Kinder',
      },
      {
        pl: 'Hiszpania',
        de: 'Spanien',
      },
      {
        pl: 'Niemcy',
        de: 'Deutschland',
      },
      {
        pl: 'Portugalia',
        de: 'Portugal',
      },
      {
        pl: 'Polska',
        de: 'Polen',
      },
      {
        pl: 'Wielka Brytania',
        de: 'Großbritannien',
      },
      {
        pl: 'Francja',
        de: 'Frankreich',
      },
      {
        pl: 'Turcja',
        de: 'die Türkei',
      },
      {
        pl: 'Lichtenstein',
        de: 'Früstentum Liechtenstein',
      },
      {
        pl: 'Austria',
        de: 'Österreich',
      },
      {
        pl: 'Szwajcaria',
        de: 'die Schweiz',
      },
      {
        pl: 'Grecja',
        de: 'Grechenland',
      },
      {
        pl: 'Jak się mówi we Włoszech?',
        de: 'Was spricht man in Italien?',
      },
      {
        pl: 'We Włoszech mówią po włosku',
        de: 'In Italien spricht man italienisch',
      },
      {
        pl: 'Jak się mówi w Niemczech?',
        de: 'Was spricht mant in in Deutschland?',
      },
      {
        pl: 'W Niemczech mówią po Niemiecku',
        de: 'In Deutshland spricht man Deutsch',
      },
      {
        pl: 'Jak się mówi we Francji?',
        de: 'Was spricht man in Frankreich?',
      },
      {
        pl: 'We Francji mówi się po francusku',
        de: 'In Frankreich spricht man Französisch',
      },
      {
        pl: 'Jak się mówi w Austrii?',
        de: 'Was spricht man in Österreich?',
      },
      {
        pl: 'W Austrii mówi się od niemiecku',
        de: 'In Österreich spricht man Deutsch',
      },
      {
        pl: 'Jak się mówi w Turcji?',
        de: 'Was spricht man in der Türkei?',
      },
      {
        pl: 'W Turcji mówią po turecku',
        de: 'In die Türkei spricht man Türkisch',
      },
      {
        pl: 'Jak się mówi w Polsce?',
        de: 'Was spricht man in Polen?',
      },
      {
        pl: 'W Polsce mówi się po polsku',
        de: 'In Polen spricht man polnisch',
      },
      {
        pl: 'W Grecji mówią po grecku',
        de: 'In Griechenland spricht man Griechisch',
      },
      {
        pl: 'W Wielkiej Brytanii mówią po angielsku',
        de: 'In Großbritannien spricht man englisch',
      },
      {
        pl: 'Skąd jesteś/pochodzisz?',
        de: 'Woher kommst du?',
      },
      {
        pl: 'Czy Pan Rossi mówi po włosku?',
        de: 'Spricht Herr Rossi Italienisch?',
      },
      {
        pl: 'Michał pochodzi z Polski',
        de: 'Michał komt aus Polen',
      },
      {
        pl: 'Mówię trochę po niemiecku',
        de: 'Ich spreche ein wenig Deutsch',
      },
      {
        pl: 'Szwajcaria',
        de: 'die Schweiz',
      },
      {
        pl: 'Jak mówią w Szwajcarii?',
        de: 'Was spricht man in der Schweiz?',
      },
      {
        pl: 'Jak mówią w Szwajcarii?',
        de: 'Was spricht man in der Schweiz?',
      },
      {
        pl: 'W Szwajcarii mówią po niemiecku, francusku, włosku i w romansz',
        de: 'In der Schweiz spricht man Deutsch, Französisch, Italienisch, Rätoromanisch',
      },
      {
        pl: 'W Portugalii mówią po portuglasku',
        de: 'In Portugal spricht man Portugiesisch',
      },
    ]
  },
  {
    name: 'Julian: Niemiecki Mod. 3 Kap 1.',
    lang: 'de',
    zdania: [ 
      {
        pl: 'Stefan, co chciałbyś zjeść w czasie przerwy? Jablko?',
        de: 'Stefan, was möchtest du in der Pause essen ? Einen Apfel?',
      },
      {
        pl: 'Nie, mamo, nie jabłko. Wolałbym zjeść batonika czekoladowego',
        de: 'Nein, Mutti, keinen Apfel. Ich esse lieber einen Schokoriegel',
      },
      {
        pl: 'A ty Tina? Co dzisiaj jesz?',
        de: "Und du Tina? Was isst du heute?",
      },
      {
        pl: 'Nic, nie jestem głodna?',
        de: "Nichts, ich habe keinen Hunger?"
      },
      {
        pl: 'Jem jabłko',
        de: 'Ich esse einen Apfel',
      },
      {
        pl: 'Jem jogurt',
        de: 'Ich esse einen Joghurt',
      },
      {
        pl: 'On je ciastko',
        de: 'Er isst einen Kuchen'
      },
      {
        pl: 'Ty jesz baton czekoladowy',
        de: 'Du isst einen Schokoriegel',
      },
      {
        pl: 'Ona pije sok',
        de: 'Sie trinkt einen Saft',
      },
      {
        pl: 'Ja jem banana',
        de: "Ich esse eine Banane"
      },
      {
        pl: 'On je gruszke',
        de: 'Er isst eine Birne',
      },
      {
        pl: 'Ona pije Cola',
        de: 'Sie trinkt eine Cola',
      },
      {
        pl: 'Oni pije lemoniadę',
        de: 'Sie trinken eine Limonade',
      },
      {
        pl: 'Wy jecie tabliczke czekolady',
        de: 'Sie essen eine Tafel Schokolade',
      },
      {
        pl: 'Ona je kawalek tortu',
        de: 'Sie isst ein Stück Torte',
      },
      {
        pl: 'Oni piją wode mineralna',
        de: 'Sie trinken ein Mineralwasser',
      },
      {
        pl: 'Wy jecie chleb z szynka',
        de: 'Sie essen Schinkenbrot',
      },
      {
        pl: 'My Jemy chipsy',
        de: 'Wir essen Chips',
      },
      {
        pl: 'Oni jedza pieczywo chrupkie',
        de: 'Sie essen Knäckebrot',
      },
      {
        pl: 'Co pijesz w czasie przerwy?',
        de: 'Was trinks du in der Pause?',
      },
      {
        pl: 'Co jesz w czasie przerwy?',
        de: 'Was isst du in deiner Pause?',
      },
      {
        pl: 'Jestem głodny',
        de: 'Ich habe Hunger',
      },
      {
        pl: 'Chce mi sie pić',
        de: 'Ich habe Durst',
      },
      {
        pl: 'Nie, nie chcę chipsow',
        de: 'Nein, ich möchte keine Chips',
      },
      {
        pl: 'Ja nie chcę ciasta',
        de: 'Ich möchte keinen Kuchen',
      },
      {
        pl: 'Ty Nie chcesz tabliczki czekolady',
        de: 'Du möchtest keine Tafel Schokolade',
      },
      {
        pl: 'On nie chce chleba z szynką',
        de: 'Er möchte kein Schinkenbrot',
      },
      {
        pl: 'stoisko z kiełbaskami',
        de: 'die Wurstbude',
      },
      {
        pl: 'potrawy / jedzienie',
        de: 'die Speise',
      },
      {
        pl: 'napój',
        de: 'das Getränk',
      },
      {
        pl: 'zupa gulaszowa',
        de: 'die Gulaschsuppe',
      },
      {
        pl: 'kiełbasa z Curry',
        de: 'die Currywurst',
      },
      {
        pl: 'kawałek',
        de: 'das Stück',
      },
      {
        pl: 'porcja frytek',
        de: "portion Pommes frites",
      },
      {
        pl: 'porcja',
        de: "die Portion",
      },
      {
        pl: 'Ile kosztuje',
        de: 'Was kostet',
      },
      {
        pl: 'Ile kosztuje hamburger?',
        de: "Was kostet ein Hamburger?",
      },
      {
        pl: 'Ile kosztuje porcja pizzy?',
        de: 'Was kostet eine Portion Pizza?',
      },
      {
        pl: 'Ile kosztuje filiżanka kawy?',
        de: "Was kostet eine Tasse Kaffee?",
      },
      {
        pl: 'Co bierzesz?',
        de: 'Was nimmst du?',
      },
      {
        pl: 'Ja biorę porcję frytek i puszkę coli',
        de: "Ich nehme eine Portion Pommes und eine Dose Cola",
      },
      {
        pl: 'On kosztuje 2,25 EUR',
        de: 'Er kostet 2,25 EUR',
      }
    ]
  }
  
]


export {
    ZDANIA
}